@include keyframes(flipOutY) {
  0% {
    opacity: 1;
    @include transform(perspective(400px) rotateY(0deg));
  }
  100% {
    opacity: 0;
    @include transform(perspective(400px) rotateY(90deg));
  }
}

@mixin flipOutY($count: $countDefault, $duration: $durationDefault, $delay: $delayDefault, $function: $functionDefault, $fill: $fillDefault, $visibility: $visibilityDefault) {
  @include animation-name(flipOutY);
  @include count($count);
  @include duration($duration);
  @include delay($delay);
  @include function($function);
  @include fill-mode($fill);
  @include visibility($visibility);
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/~/animatewithsass/_flippers/_flipOutY.scss